import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { persist } from '../configs/persist';
import { PERSIST_BLACKLIST, PERSIST_VERSION } from '../utils/global';
import createRootReducer from './ducks';
import { startListeners } from './listeners';
import { listenerMiddleware } from './middlewares';

export const configureStore = (history): { store; persistor } => {
  const rootReducer = createRootReducer(history);
  const persistedReducer = persistReducer(
    {
      key: 'root',
      version: PERSIST_VERSION,
      blacklist: PERSIST_BLACKLIST,
      storage,
    },
    rootReducer
  );
  const composeEnhancers =
    (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: true, traceLimit: 100 })) ||
    compose;
  const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(listenerMiddleware.middleware, routerMiddleware(history)))
  );
  const persistor = persistStore(store);
  persist.runMigrations(persistor);
  startListeners();
  return { store, persistor };
};
